import React from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getJiraProjectTypeKey } from '../../../services/get-jira-project-type-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, type EntryPointParams } from './entrypoint';

export function SpecialOfferSixtyModal() {
	const { cloudId, product } = useEditionAwareness();
	const projectType = getJiraProjectTypeKey(product);

	if (!projectType) {
		throw new Error(
			'Tried to render special offer sixty modal for unsupported product. Product: ' + product,
		);
	}

	const entryPointParams: EntryPointParams = {
		cloudId,
		projectType,
	};

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
